import LegalPage from '../components/ui/LegalPage.jsx'

export default function About() {
  return (
    <LegalPage
      title="About FastAudio"
      description="Learn about FastAudio — the free online video-to-MP3 converter. Fast, reliable audio extraction from YouTube, TikTok, Instagram, and Facebook."
      slug="about"
      lastUpdated="January 2025"
    >
      <p>
        FastAudio is a free online audio converter that lets you extract high-quality MP3
        audio from videos on YouTube, Instagram, TikTok, Facebook, and more — no registration,
        no software installation required.
      </p>
      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Our Mission</h2>
      <p>
        We believe everyone should be able to enjoy their favourite audio content offline,
        on any device. FastAudio was built to be the fastest, most reliable converter available,
        with up to 320 kbps audio quality and a clean, distraction-free interface.
      </p>
      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">How It Works</h2>
      <p>
        Paste a supported video URL into the converter, choose your quality setting, and click
        Convert. Our servers process the audio and make it available for download within seconds.
        Files are stored temporarily and deleted automatically — we do not keep copies of your
        downloads.
      </p>
      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Responsible Use</h2>
      <p>
        FastAudio is intended for personal, non-commercial use only. Users are responsible for
        ensuring they have the right to download and use any content they convert. Please respect
        copyright law and the terms of service of the platforms you access through this tool.
      </p>
      <p className="mt-4">
        For the current version of this page, visit{' '}
        <a href="https://fastaudio.cc/about" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
          fastaudio.cc/about
        </a>.
      </p>
    </LegalPage>
  )
}
